module.exports = {
    api: "https://apimercaleon.clomos.es",
    name: "mercaleon"
}